import CommissionsTable from './CommissionsTable';

export default CommissionsTable;
